/**
 * Map sidebar filters for GET /api/projects (API Platform property names, camelCase).
 * conventionAvailable: UI sentinel '' = no filter; 'true' / 'false' when a value is selected.
 */
export interface ProjectMapFilters {
  status: string
  conventionAvailable: string
  attributionInstance: string
  economicNature: string
  /** Inclusive lower bound; empty = no lower bound (full range from facet data). */
  fundingYearMin: string
  /** Inclusive upper bound; empty = no upper bound. */
  fundingYearMax: string
  fundingAmountMin: string
  fundingAmountMax: string
  sector: string
  fundingType: string
}

export function createEmptyProjectMapFilters(): ProjectMapFilters {
  return {
    status: '',
    conventionAvailable: '',
    attributionInstance: '',
    economicNature: '',
    fundingYearMin: '',
    fundingYearMax: '',
    fundingAmountMin: '',
    fundingAmountMax: '',
    sector: '',
    fundingType: '',
  }
}
